module.exports = __webpack_public_path__ + "img/apidays-HongKong-logowall.cdf30699.png";